import React, { useState } from 'react';

const Login = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  
  // Het wachtwoord - dit kan je aanpassen
  const correctPassword = 'zwarteduif';
  
  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (password === correctPassword) {
      onLogin();
    } else {
      setError(true);
      setTimeout(() => {
        setError(false);
      }, 3000);
    }
  };
  
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    if (error) {
      setError(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-content">
        <img src="/logo.jpg" alt="Logo" className="logo" />
        
        <h1 className="title">Veegbewijzen Aanmaken</h1>
        
        <form onSubmit={handleSubmit}>
          <div className="password-section">
            <input 
              type="password" 
              value={password}
              onChange={handlePasswordChange}
              className={`password-input ${error ? 'error' : ''}`}
              placeholder="Voer wachtwoord in"
              autoComplete="current-password"
            />
            {error && (
              <div className="error-message">
                Onjuist wachtwoord. Probeer opnieuw.
              </div>
            )}
          </div>
          
          <button type="submit" className="start-button">
            <span className="arrow-icon">→</span>
            <span>Start</span>
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;